import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { CustomerSelectorComponent } from '../../customer-selector/customer-selector.component';

export interface TenantSelectorDialogData {
	headline: string;
	description: string;
	callback?: (tenantId: string) => Promise<string | undefined>;
}

@Component({
	selector: 'app-tenant-selector-dialog',
	standalone: false,
	templateUrl: './tenant-selector-dialog.component.html',
	styleUrl: './tenant-selector-dialog.component.scss',
})
export class TenantSelectorDialogComponent {
	protected isUpdating = false;
	protected headline: string;
	protected description: string;

	protected error = '';

	protected callback?: (tenantId: string) => Promise<string | undefined>;

	constructor(
		@Inject(MAT_DIALOG_DATA) protected data: TenantSelectorDialogComponent,
		private dialogRef: MatDialogRef<TenantSelectorDialogComponent>
	) {
		this.headline = data.headline;
		this.description = data.description;
		this.callback = data.callback;
	}

	protected async update(tenant: CustomerSelectorComponent) {
		this.isUpdating = true;

		const tenantId = tenant.value;
		if (!tenantId) {
			return;
		}

		let result: any = undefined;
		if (this.callback) {
			try {
				result = await this.callback(tenantId);
			} catch (err) {
				if (err instanceof Error) {
					result = err.message;
				} else if (err instanceof HttpErrorResponse) {
					result = err.error.message;
				} else {
					result = err;
				}
			}
		}

		if (result === undefined) {
			this.close(tenantId);
		} else {
			this.error = result;
		}

		this.isUpdating = false;
	}

	public close(result: any) {
		this.dialogRef.close(result);
	}

	public cancel() {
		this.close(undefined);
	}
}
